// import React, { useState, useEffect } from 'react';
// import CustomButton from "./CustomButton";
// let resolution = window.RESOLUTION;
// let tp = 80;
// let selectedBtnIndx = 0;
// if(window.innerWidth >= 1920 && window.innerHeight >= 1080){resolution = "FHD";}else{resolution = "HD";}
// const userAgent = navigator.userAgent.toLowerCase();
// if (userAgent.includes('webos') || userAgent.includes('lg') || userAgent.includes('web0s')) {
// resolution = 'FHD';
// }
// const ModalScreen = ({shouldShowError, errTitle, errDescription, errIcon, button, okaybtn, iconWdth, iconHeight, modalOKButtonHandler, modalCANCELButtonHandler}) => {
//   const [state, setState] = useState({
//     isOKSelected: true,
//     isCANCELSelected: false
//   });
//   const {isOKSelected, isCANCELSelected} = state;
//   console.log("Modal Screen.....", isOKSelected, isCANCELSelected);
//     const styles = {
//         ModalContainer: {
//           display: shouldShowError?'flex':'none',
//           flexDirection: 'column',
//           background: 'transparent',
//           width: '100vw',
//           height: '100vh',
//           backgroundSize: 'cover',
//           backgroundPosition: 'center', // Center the background image
//           backgroundRepeat: 'no-repeat', // Do not repeat the background image
//           overflow: 'hidden',
//           position: 'absolute'
//         },
//     };
//     useEffect(() => {
//       console.log("shouldShowError..11111111..", shouldShowError);
//       if(shouldShowError){
//         console.log("shouldShowError.....22222222....", shouldShowError);
//         window.addEventListener('keydown', ModalScreenKeyHandler)
//       }else{
//         window.removeEventListener("keydown", ModalScreenKeyHandler);
//       }
//       return () => {
//         window.removeEventListener("keydown", ModalScreenKeyHandler);
//       };
//     }, [shouldShowError]);
//     const ModalScreenKeyHandler = (event) => {
//         switch(event.keyCode){
//           case 40:
//             console.log("isOKSelected ---- = ", isOKSelected, selectedBtnIndx)
//             if(selectedBtnIndx === 0){
//               setState((prevState) => ({
//                 ...prevState,
//                 isOKSelected: false,
//                 isCANCELSelected: true,
//               }));
//               selectedBtnIndx += 1;
//             }
//             break;
//           case 38:
//             console.log("isCANCELSelected ---- = ", isCANCELSelected, selectedBtnIndx)
//             if(selectedBtnIndx === 1){
//               setState((prevState) => ({
//                 ...prevState,
//                 isOKSelected: true,
//                 isCANCELSelected: false,
//               }));
//               selectedBtnIndx -= 1;
//             }
//             break;
//           case 13:
//             window.removeEventListener("keydown", ModalScreenKeyHandler);
//             if(selectedBtnIndx === 0){
//               modalOKButtonHandler(button[0])
//             }else if(selectedBtnIndx === 1){
//               modalCANCELButtonHandler()
//             }
//             break;
//           default:
//             break;
//         }
//     };
//   return (
//     <div style={styles.ModalContainer}>
//       <div style={{overflow: 'hidden', width: '100vw', height: '100vh', position: 'absolute', background: '#000000', opacity: 0.7}}></div>
//       <div style={{overflow: 'hidden', position: 'absolute', width: '100vw', height:'30vh', background: '#181818', marginTop: '70vh', zIndex: '2'}}>
//         <div style={{overflow: 'hidden', display: 'flex', justifyContent: 'center',alignItems: 'center',width: '17vw', height: '30vh',
//                      position:'absolute', background:'#0E1653'}}>
//                       <img src={errIcon} style={{width: iconWdth, height: iconHeight}}/>
//         </div>
//         <div style={{overflow: 'hidden', display: 'flex', width: '50vw', height: '30vh',
//                      position:'absolute', background:'#0E1653', marginLeft: '17vw'}}>
//                       <div style={{position: 'absolute', fontSize: '32px', marginLeft: '50px', marginTop: '10vh', color: '#FFFFFF'}}>{errTitle}</div>
//                       <div style={{position: 'absolute', fontSize: '24px', marginLeft: '50px', marginTop: '15vh', color: '#FFFFFF'}}>{errDescription}</div>
//         </div>
//         <div style={{overflow: 'hidden', display: 'flex', width: '35vw', height: '30vh',
//                      position:'absolute', background:'#0E1653', marginLeft: '63vw'}}>

//                         <CustomButton fontSize={resolution === "FHD" ? "26px" : "18px"}
//                         defaultSelected={isOKSelected}
//                         width={resolution === "FHD" ? "600px" : "169px"}
//                         height={resolution === "FHD" ? "80px" : "53px"}
//                         top={resolution === "FHD" ? "80px" : "53px"}>
//                             {button[0]}
//                         </CustomButton>

//                         <CustomButton fontSize={resolution === "FHD" ? "26px" : "18px"}
//                         defaultSelected={isCANCELSelected}
//                         width={resolution === "FHD" ? "600px" : "169px"}
//                         height={resolution === "FHD" ? "80px" : "53px"}
//                         top={resolution === "FHD" ? "170px" : "53px"}>
//                             {button[1]}
//                         </CustomButton>

//         </div>
//       </div>
//     </div>
//   );
// };
// export default ModalScreen;

import React, { useState, useEffect, useRef } from "react";
import CustomButton from "./CustomButton";
import { Translate } from "./LanguageChanger";
import { sendTestMatomoEvent } from "../Analytics/MatomoManager/matomoTest";

let resolution = window.RESOLUTION;

const RefferalPopup = ({
  shouldShowError,
  errTitle,
  errDescription,
  errIcon,
  button,
  iconWdth,
  iconHeight,
  handleOk,
  handleCancel,
  handleApplyOk,
  referralSuccess,
  shouldShowRefError,
  setState,
  referralClick,
  //   modalOKButtonHandler,
  //   modalCANCELButtonHandler,
  handleLeftInput,
  handleRightInput,
}) => {
  const [selectedBtnIndx, setSelectedBtnIndx] = useState(0); // Manage index with state
  const refferalinput = useRef();
  const [keyboardOpen, setKeyboardOpen] = useState(false);
  const [refferalInput, setRefferalInput] = useState({
    inputValue: "",
  });
 

  const handleInputFocus = () => {
    setKeyboardOpen(true);
  };
  const handleInputBlur = () => {
    setKeyboardOpen(false);
  };




const [errMsg,setErrmsg]=useState("");
  console.log(shouldShowRefError, "shouldShowRefError");

  const styles = {
    ModalContainer: {
      display: shouldShowError ? "flex" : "none",
      flexDirection: "column",
      background: "transparent",
      width: "100vw",
      height: "100vh",
      backgroundSize: "cover",
      backgroundPosition: "center",
      backgroundRepeat: "no-repeat",
      overflow: "hidden",
      position: "absolute",
      top: keyboardOpen ? "-30rem" : "0",
    },
  };


  useEffect(() => {
   if(refferalInput.inputValue){
    setErrmsg("")
   }

  if (referralClick === true) {
    console.log("Sending Matomo event for ReferralCodePopup...");
   
    sendTestMatomoEvent({
      eventCategory: "Page",
      eventAction: "View",
      eventName: "ReferralCodePopup",
    });
  }
}, [referralClick,refferalInput]);

  useEffect(() => {
    if (shouldShowError) {
      document.body.style.overflow = 'hidden';
      window.addEventListener("keydown", ModalScreenKeyHandler);
    }
    const input = refferalinput.current;
    console.log("hiii",input,keyboardOpen)
  if (!input) return;

  const handleFocus = () => setKeyboardOpen(true);
  const handleBlur = () => setKeyboardOpen(false);

  input.addEventListener("focus", handleFocus);
  input.addEventListener("blur", handleBlur);

    return () => {
      input.removeEventListener("focus", handleFocus);
      input.removeEventListener("blur", handleBlur);
      window.removeEventListener("keydown", ModalScreenKeyHandler);
      setErrmsg("")
    };
  }, [shouldShowError, selectedBtnIndx]); // Re-run when `shouldShowError` or `selectedBtnIndx` changes

  const ModalScreenKeyHandler = (event) => {
    const isInputFocused = document.activeElement === refferalinput.current;
    switch (event.keyCode) {
      case 40: // Down arrow
        if (!isInputFocused && selectedBtnIndx === 0) {
          setSelectedBtnIndx(1); // Move to Cancel button
        }
        break;
      case 38: // Up arrow
        if (selectedBtnIndx === 1) {
          setSelectedBtnIndx(0); // Move back to OK button
          
        }
        break;
      case 13: // Enter key
        if (selectedBtnIndx === 1) {
          modalCANCELButtonHandler(); // Handle Cancel action

        }
        if(selectedBtnIndx===0){
          modalOKButtonHandler1()
        }
        break;
      case 37: // Left key
        if (selectedBtnIndx === 0 || selectedBtnIndx === 1) {
          // Ensure the ref exists and is connected to a DOM element
          if (refferalinput.current) {
            // Focus the input first
            refferalinput.current.focus();

            // Use setTimeout to ensure focus completes before selection
            setTimeout(() => {
              // Get safe length (0 if value is null/undefined)
              const valueLength = refferalinput.current.value?.length || 0;

              // Set cursor to end position
              refferalinput.current.setSelectionRange(
                valueLength,
                valueLength
              );
            }, 0);
          }
          setSelectedBtnIndx(""); // Move to Cancel button
        }
        // if (selectedBtnIndx === 0 || selectedBtnIndx === 1) {
        //   refferalinput.current.focus(); // Focus on the input field
        //   setSelectedBtnIndx(""); // Move to Cancel button
        //   // handleLeftInput();
        //   //   modalOKButtonHandler(button[0]); // Handle OK action
        // }
        break;
      case 39: // Right key
        if (refferalinput.current) {
          setSelectedBtnIndx(() => 0);
          refferalinput.current.blur();
          // handleRightInput();
          //   modalOKButtonHandler(button[0]); // Handle OK action
        }
        break;

      // case 8:
      case 461:
      case 10009:
        setSelectedBtnIndx(() => 0);
        refferalinput.current.blur();
        break;
      default:
        break;
    }
  };

  //   const handleOk = () =>{
  //     modalOKButtonHandler(button[0]);
  //   }

  //   const handleCancel = () =>{
  //     modalCANCELButtonHandler();
  //   }

  const modalOKButtonHandler = (action) => {
    let Logout = action?.props?.langKey;

    switch (Logout ? Logout : action) {
      case "Login":
        // navigate("LoginScreen");
        break;
      case "Apply":
        // setRefferalInput({ inputValue: "" });
        if (localStorage.getItem("refferalCodeNumber") && refferalInput.inputValue == "") {
          localStorage.removeItem("refferalCodeNumber");
        }
        sendTestMatomoEvent({
          eventCategory: `ReferralCodePopup`,
          eventAction: `EnterCode`,
          eventName: `${refferalInput.inputValue}`,
        });

        handleApplyOk();
        // setState((prevState) => ({
        //   ...prevState,
        //   shouldShowRefError: false,

        // }));
        // refferalinput.current.blur();
        //  window. isRefferalSelected = false
        //  window.isRefferalFocus = false; 
        // handleApplyOk();
        // localStorage.removeItem("JWTToken");
        // localStorage.removeItem("userInfo");
        // const getCountry = localStorage.getItem("country");
        // let headers = {
        //   iskid: "0",
        //   Langid: "1",
        //   "Content-Type": "application/json",
        //   country: getCountry,
        // };
        // Promise.all([fetchContent("/V1/logout", "POST", headers)]);
        break;
      default:
        break;
    }
  };

  const modalOKButtonHandler1 = () => {
    console.log("modalOKButtonHandler1...", shouldShowError);
     setErrmsg("")
    setState((prev)=>({...prev}))
    if(refferalInput.inputValue!==""){
      // setRefferalInput({ inputValue: "" });
    if (localStorage.getItem("refferalCodeNumber") && refferalInput.inputValue == "") {
      localStorage.removeItem("refferalCodeNumber");
    }
     sendTestMatomoEvent({
          eventCategory: `ReferralCodePopup`,
          eventAction: `EnterCode`,
          eventName: `${refferalInput.inputValue}`,
        });

   
   
    handleApplyOk();
    }
    else{
      setErrmsg("Referral code is empty")
     
    }
  }

  const modalCANCELButtonHandler = () => {
    if (localStorage.getItem("refferalCodeNumber") && !referralSuccess) {
      localStorage.removeItem("refferalCodeNumber");
    }
    setState((prevState) => ({
      ...prevState,
      shouldShowRefError: false,
    }));
    if (localStorage.getItem("refferalCodeNumber") !== null && localStorage.getItem("refferalCodeNumber") !== undefined && localStorage.getItem("refferalCodeNumber") !== "") {
      setState((prevState) => ({
        ...prevState,
        referralSuccess: true,
      }));
    } else {
      setState((prevState) => ({
        ...prevState,
        referralSuccess: false,
      }));
    }

    // setRefferalInput({ inputValue: "" });
    // if (localStorage.getItem("refferalCodeNumber") && !referralSuccess) {
    //   localStorage.removeItem("refferalCodeNumber");
    // }
    console.log("modalCANCELButtonHandler...", shouldShowError);
    //   refferalinput.current.focus();
    console.log("modalCANCELButtonHandler...", shouldShowError);
    handleCancel();
     sendTestMatomoEvent({
      eventCategory: "ReferralCodePopup",
      eventAction: "Close",
    });




    // MenuScreen.ReseTfocus(5);
    // MenuScreen.ReseTfocus(-1);
    // setState((prevState) => ({
    //   ...prevState,
    //   shouldShowError: false,
    //   isMobile: true,
    // }));
  };

  return (
    <div style={styles.ModalContainer}>
      <div
        style={{
          overflow: "hidden",
          width: "100vw",
          height: "100vh",
          position: "absolute",
          background: "#000000",
          opacity: 0.7,
          top: "0",
          left: "0",
        }}
      ></div>
      <div
        style={{
          overflow: "hidden",
          position: "absolute",
          width: "100vw",
          height: "33.7vh",
          background: "#181818",
          marginTop: "66.4vh",
          zIndex: "2",
        }}
      >
        <div
          style={{
            overflow: "hidden",
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            width: "17vw",
            height: "33.7vh",
            position: "absolute",
            background: "#0E1653",
          }}
        >
          <img src={errIcon} style={{ width: iconWdth, height: iconHeight }} />
        </div>
        <div
          style={{
            overflow: "hidden",
            display: "flex",
            width: "53vw",
            height: "33.7vh",
            position: "absolute",
            background: "#0E1653",
            marginLeft: "12vw",
          }}
        >
          <div
            style={{
              position: "absolute",
              fontSize: "32px",
              marginLeft: "50px",
              marginTop: "10vh",
              color: "#FFFFFF",
            }}
          >
            {/* <Translate langKey={errTitle} /> */}
            {typeof errTitle === "object" ? (
              <>
                <Translate langKey={errTitle.x} />
                {" " + errTitle.y}{" "}
              </>
            ) : (
              <Translate langKey={"RefferalCode"} />
            )}
          </div>
          <div
            style={{
              position: "absolute",
              fontSize: "24px",
              marginLeft: "50px",
              marginTop: "15vh",
              //   color: '#FFFFFF',
            }}
          >
            {console.log(errDescription, "errDesc")}
              <style>
                  {`
                    input::placeholder {
                      font-family: "Anek Latin";
                      font-weight: 500;
                      font-size: 1.125rem;
                    }
                  `}
              </style>
            <input
              ref={refferalinput}
              maxLength={16}
              type="text"
              style={{
                width: "35.313vw",
                height: "5vh",
                borderRadius: "10px",
                border: shouldShowRefError && refferalInput.inputValue !== ""
                  ? "2px solid red"  
                  : "2px solid #fff",
                background: "transparent",
                color: "#FFF",
                paddingLeft: "0.75rem"
              }}
              onKeyDown={(e) => {
                if ((e.keyCode === 37 || e.keyCode === 39) && keyboardOpen) {
                  // Let the default cursor movement happen (do not preventDefault)
                  // Do NOT trigger navigation

                  const value = e.target.value;
                  const cursorPos = e.target.selectionStart;
                  if (e.keyCode === 39 && keyboardOpen) {
                    if (cursorPos < value.length) {
                      // Caret is not at end, let input handle arrow (block navigation)
                      e.stopPropagation();
                      return;
                    }
                  }
                }
                if (e.keyCode === 13 && keyboardOpen) { // Enter key
                  e.stopPropagation();
                  // Hide the Add Profile button if needed
                  setSelectedBtnIndx(0)
                  // Optionally blur the input to close the keyboard on TV
                  e.target.blur();
                  setKeyboardOpen(false); // To update your state

                  return;
                }
              }
              }
              placeholder={"Enter Referral Code"}
              value={refferalinput.current ? refferalInput.inputValue : ""}
              // onFocus={()=> setSelectedBtnIndx("")}
               onChange={(e) => {
                const value = e.target.value;

                // Update state with the new input value
                setRefferalInput({ ...refferalInput, inputValue: value });
                localStorage.setItem("refferalCodeNumber", value);
                refferalInput.inputValue.length === 0 &&
                  setState((prevState) => ({
                    ...prevState,
                    shouldShowRefError: false,
                  }));
                   const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
              }}
            />
            <p style={{ color: "red", position: "absolute", top: "2.8rem", }}>
              {errMsg
                ? errMsg
                : shouldShowRefError && refferalInput.inputValue !== ""
                  ? <Translate langKey={"Enter a valid referral code"}/>
                  : ""}
            </p>
            {/* <Translate langKey={errDescription} /> */}
            {/* {errDescription} */}
          </div>
          <div
            style={{
              position: "absolute",
              fontSize: "24px",
              marginLeft: "50px",
              //   marginTop: '15vh',
              bottom: "5vh",
              color: "#898989",
              fontFamily: "Anek Latin",
              fontWeight: '500',
            }}
          >
            {console.log(errDescription, "errDesc")}
            {/* {typeof errDescription === "object" ? (
              <>
                {" "}
                {errDescription.y}, <Translate langKey={errDescription.x} />
              </>
            ) : (
              <Translate langKey={"RefferalMsg"} />
            )} */}
            {refferalinput.inputValue == null && refferalinput.inputValue == undefined ? (
              typeof errDescription === "object" ? (
                <>
                  {errDescription.y}, <Translate langKey={errDescription.x} />
                </>
              ) : (
                <Translate langKey={"RefferalMsg"} />
              )
            ) : (
              <Translate langKey={"RefferalMsg"} />
            )}

            {/* <Translate langKey={errDescription} /> */}
            {/* {errDescription} */}
          </div>
        </div>
        <div
          style={{
            overflow: "hidden",
            // display: "flex",
            width: "35vw",
            height: "33.7vh",
            position: "absolute",
            background: "#0E1653",
            marginLeft: "65vw",
          }}
        >
          <CustomButton
            fontSize={resolution === "FHD" ? "22px" : "18px"}
            defaultSelected={selectedBtnIndx === 0} // Highlight if selected
            // width={resolution === "FHD" ? "600px" : "169px"}
            height={resolution === "FHD" ? "66px" : "53px"}
            top={resolution === "FHD" ? "80px" : "53px"}
              style={{
                  width: '592px', // Use full container width
                  marginLeft: '3px',
                  marginBottom: '16px', // Space between buttons
                  textAlign: 'center', // Center button text
                  borderRadius: '10px',
                  fontFamily: "Anek Latin",
                  fontWeight: '500',
                  marginTop: '115px',
                  border: 'none'
                }}
                onMouseEnter={() => setSelectedBtnIndx(0)}
                onClick={modalOKButtonHandler1}
          >
            {/* {button[0]} */}
            <Translate langKey={button[0]} />
          </CustomButton>

          <CustomButton
            fontSize={resolution === "FHD" ? "22px" : "18px"}
            defaultSelected={selectedBtnIndx === 1} // Highlight if selected
            // width={resolution === "FHD" ? "600px" : "169px"}
            height={resolution === "FHD" ? "66px" : "53px"}
            top={resolution === "FHD" ? "10px" : "10px"}
            // top={resolution === "FHD" ? "170px" : "53px"}
              style={{
                  width: '592px', // Use full container width
                  marginLeft: '3px',
                  marginBottom: '16px', // Space between buttons
                  textAlign: 'center', // Center button text
                  fontFamily: "Anek Latin",
                  fontWeight: '500',
                  borderRadius: '10px',
                  border: 'none'
                }}
            onMouseEnter={() => setSelectedBtnIndx(1)}
            onClick={modalCANCELButtonHandler}
          >
            {/* {button[1]} */}
            <Translate langKey={button[1]} />
          </CustomButton>
        </div>
      </div>
    </div>
  );
};

export default RefferalPopup;